/* src/app/shared/components/login/login.component.scss */
.login {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
}
a {
  color: var(--white) !important;
  font-weight: 400 !important;
}
a:hover {
  color: var(--brand-warning) !important;
}
/*# sourceMappingURL=login.component.css.map */
